import { ctas } from "./ctas";
import { sectionMetaData } from "./GeneralPage/generalSection";
import { media } from "./media";
import { metaInformation } from "./metaInformation";
import { KontentFilterable } from "./filterable";
import { richText } from "./richText";

export type columnCardGroup = {
  cards: columnCard[];
  ctas: ctas;
} & metaInformation<"columnCardGroup"> &
  sectionMetaData &
  KontentFilterable;

export type columnCard = {
  title?: string;
  body: richText; // richtext needs updating
  asset: media;
} & metaInformation<"columnCard">;

export function isColumnCardGroup(item: any): item is columnCardGroup {
  return item?.type === "columnCardGroup";
}

export function isColumnCard(item: any): item is columnCard {
  return item?.type === "columnCard";
}
